import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';

export default function BlogPage() {
  // SEO Configuration
  useSEO({
    title: 'Blog | İlkyardım İş Güvenliği Yazıları Hatay İskenderun - ASSA Akademi',
    description: 'İlkyardım, yangın güvenliği, iş güvenliği ve mesleki eğitim konularında faydalı bilgiler. Hatay İskenderun, Payas, Dörtyol, Antakya bölgesinde eğitim hizmetleri. ASSA Akademi blog yazıları.',
    keywords: 'ilkyardım blog, iş güvenliği yazıları, yangın güvenliği bilgileri, hatay eğitim blog, iskenderun ilkyardım bilgileri, payas iş güvenliği, dörtyol eğitim yazıları, antakya ilkyardım, MYK belgesi bilgi',
    canonical: '/blog',
    ogTitle: 'Blog | İlkyardım İş Güvenliği Yazıları - ASSA Akademi',
    ogDescription: 'İlkyardım, yangın güvenliği ve mesleki eğitim konularında faydalı bilgiler ve güncel içerikler.',
    ogImage: 'https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/168d15a60f9fa69a47dd6f5cc2c64efc.png',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Blog",
      "@id": "https://www.hatayilkyardım.com.tr/blog#webpage",
      "url": "https://www.hatayilkyardım.com.tr/blog",
      "name": "ASSA Akademi Blog - İlkyardım ve İş Güvenliği Yazıları",
      "description": "İlkyardım, yangın güvenliği ve mesleki eğitim konularında faydalı bilgiler ve güncel içerikler. Hatay İskenderun, Payas, Dörtyol, Antakya bölgesinde hizmet veriyoruz.",
      "isPartOf": {
        "@id": "https://www.hatayilkyardım.com.tr/#website"
      },
      "publisher": {
        "@type": "Organization",
        "name": "ASSA Akademi",
        "url": "https://www.hatayilkyardım.com.tr",
        "logo": {
          "@type": "ImageObject",
          "url": "https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/168d15a60f9fa69a47dd6f5cc2c64efc.png"
        }
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Ana Sayfa",
            "item": "https://www.hatayilkyardım.com.tr/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Blog",
            "item": "https://www.hatayilkyardım.com.tr/blog"
          }
        ]
      },
      "blogPost": [
        {
          "@type": "BlogPosting",
          "headline": "İlkyardım Eğitiminin Önemi ve Hayat Kurtarıcı Bilgiler",
          "description": "İlkyardım eğitimi, acil durumlarda hayat kurtarabilecek temel bilgi ve becerileri kazandırır.",
          "datePublished": "2025-01-15",
          "dateModified": "2025-01-15",
          "author": {"@type": "Organization", "name": "ASSA Akademi"},
          "publisher": {"@type": "Organization", "name": "ASSA Akademi"},
          "mainEntityOfPage": "https://www.hatayilkyardım.com.tr/blog"
        },
        {
          "@type": "BlogPosting",
          "headline": "Yüksekte Çalışma Güvenliği: Bilmeniz Gerekenler",
          "description": "Yüksekte çalışma, iş kazalarının en sık yaşandığı alanlardan biridir.",
          "datePublished": "2025-01-12",
          "dateModified": "2025-01-12",
          "author": {"@type": "Organization", "name": "ASSA Akademi"},
          "publisher": {"@type": "Organization", "name": "ASSA Akademi"}
        },
        {
          "@type": "BlogPosting",
          "headline": "Yangın Güvenliği ve Acil Durum Prosedürleri",
          "description": "İş yerlerinde yangın güvenliği önlemleri ve acil durum prosedürlerinin bilinmesi kritik önem taşır.",
          "datePublished": "2025-01-10",
          "dateModified": "2025-01-10",
          "author": {"@type": "Organization", "name": "ASSA Akademi"},
          "publisher": {"@type": "Organization", "name": "ASSA Akademi"}
        }
      ]
    }
  });

  const whatsappNumber = '905354971053';
  const handleWhatsAppClick = () => {
    const message = 'Merhaba, eğitimleriniz hakkında bilgi almak istiyorum.';
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const blogPosts = [
    {
      id: 1,
      title: 'İlkyardım Eğitiminin Önemi ve Hayat Kurtarıcı Bilgiler',
      excerpt: 'İlkyardım eğitimi, acil durumlarda hayat kurtarabilecek temel bilgi ve becerileri kazandırır. Hatay İskenderun\'da verdiğimiz ilkyardım eğitimleri ile toplumda farkındalık yaratıyoruz.',
      date: '15 Ocak 2025',
      category: 'İlkyardım',
      image: 'https://public.readdy.ai/ai/img_res/9584285873f24291795f7751f216824f.jpg',
      readTime: '5 dk'
    },
    {
      id: 2,
      title: 'Yüksekte Çalışma Güvenliği: Bilmeniz Gerekenler',
      excerpt: 'Yüksekte çalışma, iş kazalarının en sık yaşandığı alanlardan biridir. Doğru eğitim ve ekipman kullanımı ile bu riskleri minimize edebilirsiniz.',
      date: '12 Ocak 2025',
      category: 'İş Güvenliği',
      image: 'https://readdy.ai/api/search-image?query=height%20safety%20training%20workers%20using%20fall%20protection%20equipment%20and%20harness%20in%20professional%20training%20facility%20safety%20gear%20visible%20clean%20simple%20background&width=800&height=500&seq=blog002&orientation=landscape',
      readTime: '6 dk'
    },
    {
      id: 3,
      title: 'Yangın Güvenliği ve Acil Durum Prosedürleri',
      excerpt: 'İş yerlerinde yangın güvenliği önlemleri ve acil durum prosedürlerinin bilinmesi, can ve mal kaybını önlemek için kritik önem taşır.',
      date: '10 Ocak 2025',
      category: 'Yangın Güvenliği',
      image: 'https://readdy.ai/api/search-image?query=fire%20safety%20training%20instructor%20demonstrating%20fire%20extinguisher%20usage%20to%20workers%20in%20safety%20equipment%20industrial%20setting%20clean%20simple%20background&width=800&height=500&seq=blog003&orientation=landscape',
      readTime: '4 dk'
    },
    {
      id: 4,
      title: 'MYK Belgesi Nedir? Nasıl Alınır?',
      excerpt: 'Mesleki Yeterlilik Kurumu (MYK) belgesi, mesleki yeterliliğinizi belgeleyen resmi bir dokümandır. MYK danışmanlığı hizmetimiz ile süreçte yanınızdayız.',
      date: '8 Ocak 2025',
      category: 'Mesleki Eğitim',
      image: 'https://readdy.ai/api/search-image?query=professional%20certification%20training%20students%20receiving%20vocational%20qualification%20education%20modern%20classroom%20with%20certificates%20and%20training%20materials%20clean%20simple%20background&width=800&height=500&seq=blog004&orientation=landscape',
      readTime: '7 dk'
    },
    {
      id: 5,
      title: 'Gıda Hijyeni Eğitiminin İşletmelere Faydaları',
      excerpt: 'Gıda sektöründe çalışan personelin hijyen eğitimi alması yasal bir zorunluluktur. Bu eğitimin işletmelere sağladığı faydaları keşfedin.',
      date: '5 Ocak 2025',
      category: 'Hijyen',
      image: 'https://readdy.ai/api/search-image?query=food%20hygiene%20training%20instructor%20teaching%20sanitation%20practices%20to%20food%20service%20workers%20in%20clean%20modern%20training%20room%20hygiene%20materials%20simple%20background&width=800&height=500&seq=blog005&orientation=landscape',
      readTime: '5 dk'
    },
    {
      id: 6,
      title: 'İş Güvenliği Eğitimlerinin Yasal Gereklilikleri',
      excerpt: 'İş Sağlığı ve Güvenliği Kanunu kapsamında işverenlerin çalışanlarına vermesi gereken zorunlu eğitimler ve yasal sorumluluklar.',
      date: '3 Ocak 2025',
      category: 'İş Güvenliği',
      image: 'https://readdy.ai/api/search-image?query=workplace%20safety%20training%20legal%20requirements%20instructor%20teaching%20occupational%20health%20and%20safety%20to%20workers%20professional%20setting%20clean%20simple%20background&width=800&height=500&seq=blog006&orientation=landscape',
      readTime: '6 dk'
    },
    {
      id: 7,
      title: 'CPR (Kalp Masajı) Tekniklerinde Güncel Uygulamalar',
      excerpt: 'Kalp masajı tekniklerindeki son gelişmeler ve doğru uygulama yöntemleri. İlkyardım eğitimlerimizde öğrettiğimiz hayat kurtaran beceriler.',
      date: '1 Ocak 2025',
      category: 'İlkyardım',
      image: 'https://readdy.ai/api/search-image?query=CPR%20cardiopulmonary%20resuscitation%20training%20medical%20instructor%20demonstrating%20chest%20compression%20technique%20on%20mannequin%20professional%20healthcare%20education%20setting%20clean%20simple%20background&width=800&height=500&seq=blog007&orientation=landscape',
      readTime: '5 dk'
    },
    {
      id: 8,
      title: 'İş Yerinde Kişisel Koruyucu Donanım Kullanımı',
      excerpt: 'Kişisel koruyucu donanımların doğru seçimi ve kullanımı iş kazalarını önlemede kritik rol oynar. İş güvenliği eğitimlerimizde detaylı bilgi veriyoruz.',
      date: '29 Aralık 2024',
      category: 'İş Güvenliği',
      image: 'https://readdy.ai/api/search-image?query=personal%20protective%20equipment%20PPE%20training%20worker%20wearing%20safety%20helmet%20gloves%20and%20vest%20in%20industrial%20workplace%20professional%20safety%20gear%20demonstration%20clean%20simple%20background&width=800&height=500&seq=blog008&orientation=landscape',
      readTime: '6 dk'
    },
    {
      id: 9,
      title: 'Elektrik Güvenliği ve Önleyici Tedbirler',
      excerpt: 'Elektrikle çalışan personelin bilmesi gereken güvenlik kuralları ve elektrik kazalarını önleme yöntemleri hakkında kapsamlı bilgiler.',
      date: '27 Aralık 2024',
      category: 'İş Güvenliği',
      image: 'https://readdy.ai/api/search-image?query=electrical%20safety%20training%20technician%20with%20safety%20equipment%20working%20on%20electrical%20panel%20wearing%20protective%20gear%20industrial%20setting%20clean%20simple%20background&width=800&height=500&seq=blog009&orientation=landscape',
      readTime: '7 dk'
    },
    {
      id: 10,
      title: 'Boğulma Vakalarında İlkyardım Müdahalesi',
      excerpt: 'Boğulma acil durumlarında yapılması gerekenler ve Heimlich manevrası uygulaması. İlkyardım eğitimlerimizde pratik yaparak öğrenin.',
      date: '25 Aralık 2024',
      category: 'İlkyardım',
      image: 'https://readdy.ai/api/search-image?query=choking%20first%20aid%20Heimlich%20maneuver%20demonstration%20instructor%20teaching%20emergency%20response%20technique%20to%20students%20medical%20training%20classroom%20clean%20simple%20background&width=800&height=500&seq=blog010&orientation=landscape',
      readTime: '4 dk'
    },
    {
      id: 11,
      title: 'Kimyasal Madde Güvenliği ve MSDS Bilgileri',
      excerpt: 'İş yerlerinde kullanılan kimyasal maddelerin güvenli kullanımı ve Malzeme Güvenlik Bilgi Formları (MSDS) hakkında bilmeniz gerekenler.',
      date: '23 Aralık 2024',
      category: 'İş Güvenliği',
      image: 'https://readdy.ai/api/search-image?query=chemical%20safety%20training%20worker%20in%20protective%20suit%20handling%20hazardous%20materials%20laboratory%20setting%20safety%20equipment%20visible%20clean%20simple%20background&width=800&height=500&seq=blog011&orientation=landscape',
      readTime: '6 dk'
    },
    {
      id: 12,
      title: 'Yanık Vakalarında İlkyardım Uygulamaları',
      excerpt: 'Farklı derece yanıklarda yapılması ve yapılmaması gerekenler. İlkyardım eğitimlerimizde öğrettiğimiz doğru müdahale teknikleri.',
      date: '21 Aralık 2024',
      category: 'İlkyardım',
      image: 'https://readdy.ai/api/search-image?query=burn%20injury%20first%20aid%20treatment%20medical%20instructor%20demonstrating%20proper%20burn%20care%20technique%20with%20medical%20supplies%20healthcare%20training%20setting%20clean%20simple%20background&width=800&height=500&seq=blog012&orientation=landscape',
      readTime: '5 dk'
    },
    {
      id: 13,
      title: 'Forklift Operatörlüğü ve Güvenli Kullanım',
      excerpt: 'Forklift kullanımında dikkat edilmesi gereken güvenlik kuralları ve operatör eğitiminin önemi. Mesleki eğitim programlarımızda sertifikalı eğitim.',
      date: '19 Aralık 2024',
      category: 'Mesleki Eğitim',
      image: 'https://readdy.ai/api/search-image?query=forklift%20operator%20training%20professional%20instructor%20teaching%20warehouse%20safety%20and%20forklift%20operation%20skills%20in%20industrial%20facility%20clean%20simple%20background&width=800&height=500&seq=blog013&orientation=landscape',
      readTime: '7 dk'
    },
    {
      id: 14,
      title: 'Kapalı Alan Çalışmalarında Güvenlik',
      excerpt: 'Kapalı ve dar alanlarda çalışırken alınması gereken önlemler ve özel eğitim gereksinimleri hakkında detaylı bilgiler.',
      date: '17 Aralık 2024',
      category: 'İş Güvenliği',
      image: 'https://readdy.ai/api/search-image?query=confined%20space%20safety%20training%20worker%20with%20breathing%20apparatus%20and%20safety%20equipment%20entering%20restricted%20area%20industrial%20setting%20clean%20simple%20background&width=800&height=500&seq=blog014&orientation=landscape',
      readTime: '6 dk'
    },
    {
      id: 15,
      title: 'Kırık ve Çıkıklarda İlkyardım Müdahalesi',
      excerpt: 'Kemik kırıkları ve eklem çıkıklarında doğru ilkyardım uygulamaları. Atel yapımı ve taşıma teknikleri hakkında bilgiler.',
      date: '15 Aralık 2024',
      category: 'İlkyardım',
      image: 'https://readdy.ai/api/search-image?query=fracture%20first%20aid%20splinting%20technique%20medical%20instructor%20demonstrating%20bone%20fracture%20treatment%20and%20immobilization%20method%20healthcare%20training%20clean%20simple%20background&width=800&height=500&seq=blog015&orientation=landscape',
      readTime: '5 dk'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="mb-8">
            <Link to="/" className="text-teal-400 hover:text-teal-300 flex items-center text-sm whitespace-nowrap">
              <i className="ri-arrow-left-line mr-2"></i>
              Ana Sayfaya Dön
            </Link>
          </nav>
          <h1 className="text-5xl font-bold mb-4">Blog</h1>
          <p className="text-xl text-gray-300 max-w-3xl">
            İş güvenliği, ilkyardım ve mesleki eğitim konularında faydalı bilgiler ve güncel içerikler
          </p>
        </div>
      </header>

      {/* Blog Posts */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogPosts.map(post => (
              <article key={post.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all group">
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4 bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                    {post.category}
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <i className="ri-calendar-line mr-2"></i>
                    <span>{post.date}</span>
                    <span className="mx-2">•</span>
                    <i className="ri-time-line mr-1"></i>
                    <span>{post.readTime} okuma</span>
                  </div>

                  <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {post.title}
                  </h2>

                  <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                    {post.excerpt}
                  </p>

                  <button className="text-teal-600 font-semibold flex items-center group-hover:text-teal-700 whitespace-nowrap">
                    Devamını Oku
                    <i className="ri-arrow-right-line ml-2"></i>
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-r from-gray-50 to-gray-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-2xl p-12 shadow-lg">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-mail-line text-3xl text-teal-600"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Eğitim Haberlerini Kaçırmayın
            </h2>
            <p className="text-gray-600 mb-8">
              Yeni eğitim programları, blog yazıları ve özel fırsatlardan haberdar olmak için bültenimize abone olun
            </p>
            <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent outline-none"
              />
              <button className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap">
                Abone Ol
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-r from-teal-600 to-teal-700 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Eğitimlerimiz Hakkında Bilgi Almak İster Misiniz?
          </h2>
          <p className="text-xl text-teal-50 mb-8">
            Profesyonel eğitim programlarımız için hemen iletişime geçin
          </p>
          <button
            onClick={handleWhatsAppClick}
            className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-bold text-lg transition-all inline-flex items-center space-x-2 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span>WhatsApp ile İletişime Geç</span>
          </button>
        </div>
      </section>

      {/* Floating WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 w-14 h-14 bg-teal-600 hover:bg-teal-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all z-40 flex items-center justify-center"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </button>
    </div>
  );
}
